import { Button } from 'antd';
import { Google } from '../../../assets/CustomIcons/Google';

interface AuthButtonProps {
  onClick: () => void;
}

export const GoogleButton: React.FC<AuthButtonProps> = ({ onClick }) => {
  return (
    <Button
      className="auth-submit-button flex items-center justify-between bg-brand-white border border-neutral-500 mb-4"
      shape="round"
      onClick={onClick}
    >
      <Google className="flex-shrink-0" />
      <div className="mx-auto text-base text-brand-grey-dark font-figtree font-semibold pr-8">Continue with Google</div>
    </Button>
  );
};
